import { ThirdPartyPlaylistResponse } from './types';

export async function fetchSpotifyPlaylist(): Promise<ThirdPartyPlaylistResponse> {
  const response = await fetch(`/api/proxy/v3/music/spotify/playlists`, {
    method: 'GET',
    credentials: 'same-origin',
  });
  if (response.ok) {
    return response.json();
  }
  throw new Error(`Could not fetch user's playlists`);
}
